import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getDeviceType } from "../helper";
import NativeShare from "./NativeShare";

export default function ShareNow() {
  const [share, setshare] = useState(false);
  let title1 =
    "I just directly wrote to PM Modi to ask for exam advice. Got a question? Ask now through the Warriors Hotline! Exam Warriors can connect directly via the NaMo App #PPC2024";
  let link = "https://www.narendramodi.in/ppc_dm_to_pm";

  let share_text = title1;
  let tlink = "https://twitter.com/intent/tweet?text=";
  let flink = "https://www.facebook.com/dialog/feed?app_id=445815495479697";
  var facebookLink = `${flink}&link=${encodeURIComponent(
    link
  )}&quote=${share_text}&www.facebook.com=1`;
  var twitterLink = `${tlink} ${encodeURIComponent(
    share_text + "\n\n" + link
  )}&www.facebook.com=1`;
  const whatsappShareLink =
    "https://api.whatsapp.com/send?text=" +
    encodeURIComponent(share_text + "  " + link) +
    "&www.facebook.com=1";

  const getShare = () => {
    setshare(true);
  };

  return (
    <div
      className="modal fade"
      id="sharenow"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content modal_form">
          <div className="modal-header">
            <h5 className="modal-title">Thanks for posting. Share Now!</h5>

            <img
              src="/images/plus.png"
              className="close_modal"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body share_modl">
            <a
              target="_blank"
              href={facebookLink}
              onClick={() => {
                try {
                  let obj = {
                    platform: getDeviceType(),
                  };
                  window.gtag("event", "shared_on_facebook", obj);
                } catch (error) {}
              }}
            >
              <img src="/images/facebook.png" />
            </a>
            <a
              target="_blank"
              href={twitterLink}
              onClick={() => {
                try {
                  let obj = {
                    platform: getDeviceType(),
                  };
                  window.gtag("event", "shared_on_twitter", obj);
                } catch (error) {}
              }}
            >
              <img src="/images/twitter.png" />
            </a>

            <a
              target="_blank"
              href={whatsappShareLink}
              onClick={() => {
                try {
                  let obj = {
                    platform: getDeviceType(),
                  };
                  window.gtag("event", "shared_on_WhatsApp", obj);
                } catch (error) {}
              }}
            >
              <img src="/images/whatsapp.png" />
            </a>
            <NativeShare getShare={getShare} sharenow={true} />
            {/* <a target="_blank">
              <img src="/images/share.png" />
            </a> */}
          </div>
          {/* <div className="modal-footer">
            <button type="button" className=" btn_submit" data-dismiss="modal">
              Share Now
            </button>
            <button type="button" className=" btn_submit" data-dismiss="modal">
              Please Share
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
}
